import Cropper from "cropperjs"

const DEFAULTS = {
  viewMode: 1,
  dragMode: "move",
  autoCropArea: 0.9,
  cropBoxResizable: true,
  background: true,
  guides: true,
  center: true,
  responsive: true
}

export function initCropper(imageElement, options = {}) {
  return new Cropper(imageElement, { ...DEFAULTS, ...options })
}

export function destroyCropper(instance) {
  if (instance) instance.destroy()
  return null
}

export function getCroppedBlob(cropper, options = {}) {
  const canvasOpts = {
    maxWidth: 2048,
    maxHeight: 2048,
    imageSmoothingEnabled: true,
    imageSmoothingQuality: "high",
    ...options
  }

  // PNG preserves the alpha channel (transparent template/pattern covers);
  // JPEG flattens transparency to black, so it stays the default for photos.
  const mime = options.format === "png" ? "image/png" : "image/jpeg"

  return new Promise((resolve) => {
    const canvas = cropper.getCroppedCanvas({ fillColor: "transparent", ...canvasOpts })
    if (!canvas) return resolve(null)
    canvas.toBlob((blob) => resolve(blob), mime, options.quality || 0.92)
  })
}

export function rotateImage(imageElement, degrees, callback) {
  const canvas = document.createElement("canvas")
  const ctx = canvas.getContext("2d")

  canvas.width = imageElement.naturalHeight
  canvas.height = imageElement.naturalWidth

  ctx.translate(canvas.width / 2, canvas.height / 2)
  ctx.rotate((degrees * Math.PI) / 180)
  ctx.drawImage(imageElement, -imageElement.naturalWidth / 2, -imageElement.naturalHeight / 2)

  imageElement.onload = callback
  imageElement.src = canvas.toDataURL("image/jpeg", 0.95)
}

// Presets for common crop configurations
export const CROPPER_PRESETS = {
  default: {},
  photo: { autoCropArea: 0.9 },
  scan: { autoCropArea: 0.85 },
  avatar: { aspectRatio: 1, autoCropArea: 0.9, minContainerWidth: 300, minContainerHeight: 300 }
}

// Destroy current cropper, rotate image, reinitialize with preset
export function applyRotation(cropperRef, imageElement, degrees, preset = "default") {
  destroyCropper(cropperRef)
  return new Promise((resolve) => {
    rotateImage(imageElement, degrees, () => {
      resolve(initCropper(imageElement, CROPPER_PRESETS[preset] || {}))
    })
  })
}

// Bind/unbind click handlers on teleported modals (outside Stimulus DOM)
export function bindModalActions(modal, handlers) {
  modal.querySelectorAll("[data-modal-action]").forEach(btn => {
    const action = btn.dataset.modalAction
    if (handlers[action]) btn.addEventListener("click", handlers[action])
  })
  return handlers
}

export function unbindModalActions(modal, handlers) {
  if (!handlers) return null
  modal.querySelectorAll("[data-modal-action]").forEach(btn => {
    const action = btn.dataset.modalAction
    if (handlers[action]) btn.removeEventListener("click", handlers[action])
  })
  return null
}

export function lockBodyScroll() {
  document.body.classList.add("overflow-hidden")
}

export function unlockBodyScroll() {
  document.body.classList.remove("overflow-hidden")
}
